enum PubAdsMethods {
	CLEAR_TARGETING = 'clearTargeting',
	COLLAPSE_EMPTY_DIVS = 'collapseEmptyDivs',
	DISABLE_INITIAL_LOAD = 'disableInitialLoad',
	ENABLE_LAZY_LOAD = 'enableLazyLoad',
	ENABLE_SINGLE_REQUEST = 'enableSingleRequest',
	GET_TARGETING = 'getTargeting',
	REFRESH = 'refresh',
	SET_TARGETING = 'setTargeting',
}

// Banners of the "standard" type are not relevant for the search page.
enum BannerTypes {
	ADVANCED = 'advanced',
	MOBILE_ADVANCED = 'mobileAdvanced',
	TOP = 'top',
}

enum AdTargetingOptions {
	DISCIPLINE = 'discipline',
}

declare interface ILazyLoadParams {
	fetchMarginPercent?: number;
	renderMarginPercent?: number;
	mobileScaling?: number;
}

declare interface IGoogleTagCMD {
	push: (callback: () => void) => void;
}

declare interface IPubAds {
	[PubAdsMethods.CLEAR_TARGETING]?: (key: AdTargetingOptions) => void;
	[PubAdsMethods.COLLAPSE_EMPTY_DIVS]?: () => void;
	[PubAdsMethods.DISABLE_INITIAL_LOAD]?: () => void;
	[PubAdsMethods.ENABLE_LAZY_LOAD]?: (params: ILazyLoadParams) => void;
	[PubAdsMethods.ENABLE_SINGLE_REQUEST]?: () => void;
	[PubAdsMethods.GET_TARGETING]: (key: AdTargetingOptions) => string[];
	[PubAdsMethods.REFRESH]?: (slots: IDefinedSlot[]) => void;
	[PubAdsMethods.SET_TARGETING]?: (key: AdTargetingOptions, value: string | string[]) => void;
}

declare interface IDefinedSlot {
	addService?: (pubAds: IPubAds) => void;
	defineSizeMapping?: (mapping: ISizeMapping) => void;
	getSlotElementId: () => string;
}

declare interface ISizeMapping {
	addSize?: (viewportSize: [number, number], slotSize: [number, number][]) => ISizeMapping;
	build?: () => ISizeMapping;
}

declare interface IGoogleTag {
	cmd?: IGoogleTagCMD;
	defineSlot?: (adUnitPath: string, size: [number, number], id?: string) => IDefinedSlot;
	display?: (containerId: string) => void;
	pubads?: () => IPubAds;
	pubadsReady: boolean;
	sizeMapping?: () => ISizeMapping;
	enableServices?: () => void;
}

declare interface IAdUnit {
	dimensions: [number, number];
	code: string;
	containerID: string;
}

declare interface IAdTargetingRule {
	key: string;
	value: string;
}

type TAdSlots = {
	[key in BannerTypes]?: IDefinedSlot[];
};

interface IGamReadyEvent extends CustomEvent {
	detail: {
		units?: IAdUnit[];
		targeting?: IAdTargetingRule[];
	};
}

export {
	PubAdsMethods,
	ILazyLoadParams,
	IPubAds,
	IDefinedSlot,
	ISizeMapping,
	IGoogleTag,
	IAdUnit,
	IAdTargetingRule,
	BannerTypes,
	TAdSlots,
	IGamReadyEvent,
	AdTargetingOptions,
};
